import React, { FC } from 'react'

import { EInvoicingNetworkConfig } from '@features/eInvoicingSettings/types'

export type EInvoicingSettingsContext = 'Purchase' | 'Organization'

export type EInvoicingSettingsComponent<
  NetworkSettings extends EInvoicingNetworkConfig = EInvoicingNetworkConfig,
  Props extends Record<string, any> = {},
> = React.FunctionComponent<{ networkSettings: NetworkSettings; context?: EInvoicingSettingsContext } & Props>

export interface NullableEInvoicingSettingsProps {
  networkSettings: EInvoicingNetworkConfig | null
  settingsComponent: EInvoicingSettingsComponent
  context?: EInvoicingSettingsContext
}

export const NullableEInvoicingSettings: FC<NullableEInvoicingSettingsProps> = ({
  networkSettings,
  settingsComponent: SettingsComponent,
  context,
}) => {
  if (!networkSettings) {
    return null
  }

  return <SettingsComponent networkSettings={networkSettings} context={context} />
}
